import Helpers from '@/mixins/helpers';

const apiTpr =
	(window as any).AppMode === "app"
		? "https://tprappv2.azurewebsites.net/"
		: (window as any).AppMode === "sit4"
		? "https://tprappv3-dev-aybnecg5gmf9ahdf.australiaeast-01.azurewebsites.net/"
		: (window as any).AppMode === "uat"
		? "https://tprappv3-nonprod-ckeecqbpaefsd0hm.australiaeast-01.azurewebsites.net/"
		: "https://tprappv2-dev.azurewebsites.net/";

export function returnTprPostURL(): string {
	return apiTpr + "tpr/v3/Entanglement/QuoteCreate";
}

export function returnGuidCheckUrl(guid: string): string {
	return apiTpr + 'tpr/v1/expiry?guest=' + guid;
}

export async function checkGuid(guid: string, expiry: string, callback?: any): Promise<any> {
	const url = returnGuidCheckUrl(guid);
	return await fetch(url).then(r => {
		if (!r.ok) throw new Error(`guid check responded ${r.status}`);
		return r.text();
	}).then(t => t.replace('"', '').replace('"', '')).then((response) => {
		const rExpiry = new Date(response);
		const gExpiry = new Date(expiry);

		// Simple date comparison: expiry date should be <= response date
		const isValid = gExpiry <= rExpiry;
		if (callback){
			callback(isValid, response);
		}
		return { isValid, dateString: response, isError: false };
	}).catch(function(response){
		console.log(response);
		if (callback){
			callback(false);
		}
		return { isValid: false, dateString: '', isError: true };
	});
}
export const doOverridesWithMutations = (preApprovalObj: any, quoteObj: any) => {
	if (location.host.includes('tpr.tfa.local') || location.host.includes('sit4')){
		const urlParams = new URLSearchParams(window.location.search);
		const preApprovalStatus = urlParams.get('preApprovalStatus');
		if (typeof preApprovalStatus == 'string'){
			console.log('overriding preApprovalStatus')
			preApprovalObj.preApprovalStatus = preApprovalStatus;
		}
		const eligibilityOutcome = urlParams.get('eligibilityOutcome');
		if (typeof eligibilityOutcome == 'string'){
			console.log('overriding eligibilityOutcome');
			quoteObj.eligibilityOutcome = eligibilityOutcome;
		}
	}
}
export const updateQuoteApi = async (obj: any): Promise<any> => {
	const url = `${apiTpr}/tpr/v3/Entanglement/UpdateQuote`;
	return await fetch(url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(obj)
	}).then(res => {
		if (!res.ok) throw new Error(`api responded ${res.status}`);
		return res.json();
	}).catch((e) => {
		console.log(e);
		return null;
	});
};

export const updateRepaymentsApi = async (obj: any): Promise<any> => {
	const url = `${apiTpr}/tpr/v3/Entanglement/UpdateRepayments`;
	return await fetch(url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(obj)
	}).then(res => {
		if (!res.ok) throw new Error(`api responded ${res.status}`);
		return res.json();
	}).then((json) => {
		// a failed response has no alfaFinancialResponse to backfill or override;
		// touching it would throw and turn the failure body into null
		if (!json.success) return json;
		if (!json.alfaFinancialResponse?.customerDomain?.customerInteraction?.preApproval){
			const newObj = JSON.parse(JSON.stringify(Helpers.blankUpdateRepayments));
			json.alfaFinancialResponse.customerDomain.customerInteraction.preApproval = newObj.alfaFinancialResponse.customerDomain.customerInteraction.preApproval;
		}
		doOverridesWithMutations(json.alfaFinancialResponse.customerDomain.customerInteraction.preApproval, json.alfaFinancialResponse.customerDomain.customerInteraction.quote);
		return json;
	}).catch((e) => {
		console.log(e);
		return null;
	});
};

export const retrieveQuoteApi = async (pegaCaseTracking: string, accessToken: string): Promise<any> => {
	const url = `${apiTpr}/tpr/v3/Entanglement/Retrieve`;
	const obj = {
		"pegaCaseTracking": pegaCaseTracking,
		"accessToken": accessToken
	};
	return await fetch(url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(obj)
	}).then(res => {
		if (!res.ok) throw new Error(`api responded ${res.status}`);
		return res.json();
	}).then(json => {
		if (json.success){
			doOverridesWithMutations(json.response.customerDomain.customerInteraction.preApproval, json.response.customerDomain.customerInteraction.quote);
		}
		return json;
	}).catch((e) => {
		console.log(e);
		return null;
	});
};

export const lastSavedQuote = async (pegaCaseTracking: string, accessToken: string, dealerId: any): Promise<any> => {
	const url = `${apiTpr}/tpr/v3/Entanglement?CaseID=${pegaCaseTracking}&Guid=${accessToken}&DealerID=${dealerId}`;
	return await fetch(url, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json'
		}
	}).then(res => {
		if (!res.ok) {
			console.log(`api responded ${res.status}`);
			return null;
		}
		return res.json();
	}).catch((e) => {
		console.log(e);
		return null;
	});
};
